export const NEXT = 'Næste';
export const PREVIOUS = 'Forrige';